// Styles
import { ChevronRightExtraSmall } from "../icons";
import { useSimpleBreadcrumbStyles } from "./SimpleBreadcrumb.styles";
// Utilities
import * as React from "react";
import { getBreadcrumbString } from "@ms/uno-utilities/lib/local/StringUtilities";
import { customizeStyles } from "../utilities/StyleUtilities";
/**
 * Renders a string-only breadcrumb with chevrons between each item using Fluent UI v9
 */ export const SimpleBreadcrumb = (props)=>{
    const { breadcrumbStrings, keySuffix, customStyles } = props;
    // Get styles
    const styles = customizeStyles(useSimpleBreadcrumbStyles(), customStyles);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.root
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.wrapper,
        title: getBreadcrumbString(breadcrumbStrings)
    }, breadcrumbStrings.map((breadcrumb, index)=>{
        return /*#__PURE__*/ React.createElement(React.Fragment, {
            key: `${keySuffix}${index}`
        }, index !== 0 && /*#__PURE__*/ React.createElement("div", {
            className: styles.chevron
        }, /*#__PURE__*/ React.createElement(ChevronRightExtraSmall, null)), /*#__PURE__*/ React.createElement("span", {
            className: styles.item
        }, breadcrumb));
    })));
};
